<template>
  <div id="energy" class="form" :class="$mq">
    <h3>{{ $t("step1.title") }}</h3>

    <div class="section" :class="$mq">
      <div class="title">{{ $t("step1.energy.title") }}</div>
      <div class="container inline bottom">
        <div
          class="frame content-centered"
          :class="{active: type === 'elec'}"
          @click="type = 'elec'"
        >
          <h4>{{ $t("elec") }}</h4>
          <SvgIcon icon="elec" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
        <div
          class="frame content-centered"
          :class="{active: type === 'both'}"
          @click="type = 'both'"
        >
          <h4>{{ $t("dual") }}</h4>
          <SvgIcon icon="dual" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
        <div class="frame content-centered" :class="{active: type === 'gas'}" @click="type = 'gas'">
          <h4>{{ $t("gas") }}</h4>
          <SvgIcon icon="gas" class="icon content-centered" fill />
          <div class="check-button radio"></div>
        </div>
      </div>
    </div>

    <div class="button inline">
      <button @click="nextStep()" class="stroke">{{ $t('continue') }}</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    type: {
      get() {
        return this.$store.state.energy.type;
      },
      set(value) {
        this.$store.commit("comparison/reset");
        this.$store.commit("consumption/setValid", false);
        this.$store.commit("energy/setType", value);
      }
    }
  },
  methods: {
    nextStep: async function() {
      this.$store.commit("energy/setValid", true);
      this.$store.dispatch("common/save");
      this.$store.dispatch("energy/save");
      this.$router.push({ name: "Consumption", query: this.$route.query });
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.$store.dispatch("common/setUuid");
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Energy.vue